export const WEEK_DAYS = {
	'7': 'Sundays',
	'1': 'Monday',
	'2': 'Tuesday',
	'3': 'Wednesday',
	'4': 'Thursday',
	'5': 'Friday',
	'6': 'Saturday'
};
export const WeeksCount = [
	{ value: '1', label: '1' },
	{ value: '2', label: '2' },
	{ value: '3', label: '3' },
	{ value: '4', label: '4' }
];

export const Months = [
	{ value: '1', label: '1' },
	{ value: '2', label: '2' },
	{ value: '3', label: '3' },
	{ value: '4', label: '4' },
	{ value: '5', label: '5' },
	{ value: '6', label: '6' },
	{ value: '7', label: '7' },
	{ value: '8', label: '8' },
	{ value: '9', label: '9' },
	{ value: '10', label: '10' },
	{ value: '11', label: '11' }
];

export const Days = [{
	'value': '1',
	'label': '1'
}, {
	'value': '2',
	'label': '2'
}, {
	'value': '3',
	'label': '3'
}, {
	'value': '4',
	'label': '4'
}, {
	'value': '5',
	'label': '5'
}, {
	'value': '6',
	'label': '6'
}, {
	'value': '7',
	'label': '7'
}, {
	'value': '8',
	'label': '8'
}, {
	'value': '9',
	'label': '9'
}, {
	'value': '10',
	'label': '10'
}, {
	'value': '11',
	'label': '11'
}, {
	'value': '12',
	'label': '12'
}, {
	'value': '13',
	'label': '13'
}, {
	'value': '14',
	'label': '14'
}, {
	'value': '15',
	'label': '15'
}, {
	'value': '16',
	'label': '16'
}, {
	'value': '17',
	'label': '17'
}, {
	'value': '18',
	'label': '18'
}, {
	'value': '19',
	'label': '19'
}, {
	'value': '20',
	'label': '20'
}, {
	'value': '21',
	'label': '21'
}, {
	'value': '22',
	'label': '22'
}, {
	'value': '23',
	'label': '23'
}, {
	'value': '24',
	'label': '24'
}, {
	'value': '25',
	'label': '25'
}, {
	'value': '26',
	'label': '26'
}, {
	'value': '27',
	'label': '27'
}, {
	'value': '28',
	'label': '28'
}, {
	'value': '29',
	'label': '29'
}, {
	'value': '30',
	'label': '30'
}, {
	'value': '31',
	'label': '31'
}];

export const WeekDayfield = {
	isMulti: false,
	isOpenTop: false,
	value: '',
	name: 'every_period',
	subtitle: 'How frequently do you want to be notified?',
	fieldLabel: 'Frequency',
	key: 'every_period',
	type: 'select',
	trackVal: 'reminder_settings_frequency',
	validation: {
		required: {
			msg: 'Required!'
		}
	},
	options: WeeksCount
};

export const MonthField = {
	isMulti: false,
	isOpenTop: false,
	value: '',
	name: 'every_period',
	subtitle: 'How frequently do you want to be notified?',
	fieldLabel: 'Frequency',
	key: 'every_period',
	type: 'select',
	trackVal: 'reminder_settings_frequency',
	validation: {
		required: {
			msg: 'Required!'
		}
	},
	options: Months
};

export const DayField = {
	isMulti: false,
	isOpenTop: false,
	value: '',
	name: 'on_day',
	subtitle: 'How frequently do you want to be notified?',
	fieldLabel: 'on_day',
	key: 'on_day',
	type: 'select',
	trackVal: 'on_day',
	validation: {
		required: {
			msg: 'Required!'
		}
	},
	options: Days
};

export const DailyField = {
	isMulti: false,
	isOpenTop: false,
	value: '',
	name: 'every_period',
	subtitle: 'How frequently do you want to be notified?',
	fieldLabel: 'every_period',
	key: 'every_period',
	type: 'select',
	trackVal: 'every_period',
	validation: {
		required: {
			msg: 'Required!'
		}
	},
	options: Days
};

export const WeekField = {
	isMulti: false,
	isOpenTop: false,
	value: '',
	name: 'on_day',
	subtitle: 'How frequently do you want to be notified?',
	fieldLabel: 'on_day',
	key: 'on_day',
	type: 'radio',
	trackVal: 'on_day',
	validation: {
		required: {
			msg: 'Required!'
		}
	},
	customClass: 'weekDays',
	options: [
		{ label: 'M', value: '1' },
		{ label: 'T', value: '2' },
		{ label: 'W', value: '3' },
		{ label: 'T', value: '4' },
		{ label: 'F', value: '5' },
		{ label: 'S', value: '6' },
		{ label: 'S', value: '7' }

	]
};
